<template>
  <div>
    <template v-for="(b,i) in navList">
      <a :style="getStyle(b)" :key="i"
       :title="b.disabled ? b.labelDisable : b.label"
       :class="b.disabled ? 'pk-nav-item-disabled' : ''"
       v-on:click="clickNavItem(b)"><img :src="b.disabled ? getIcon(b.imgDisable) : b.active ? getIcon(b.imgActive) : getIcon(b.img)"></a>
    </template>
  </div>
</template>

<script>
import Vue from 'vue';
export default Vue.extend({
  props: {
    navList: Array,
    itemClass: String
  },
  data() {
    return {};
  },
  mounted() {
    this.enableDisableSlTextButton();
    this.enableDisableSSRiButton();
    this.enableDisableSSTextButton();
    this.enableDisableSlRiButton();
    this.enableDisableSlDetailButton();
    this.enableDisableSlScreenImageButton();
  },
  watch: {
    'activeSlide'() {
      this.enableDisableSlTextButton();
    },
    'activeSlideset.relatedItems.length'() {
      this.enableDisableSSRiButton();
    },
    'activeSlideset.texts.length'() {
      this.enableDisableSSTextButton();
    },
    'activeSlide.relatedItems.length'() {
      this.enableDisableSlRiButton();
    },
    'activeSlide.$_images.length'() {
      this.enableDisableSlDetailButton();
      this.enableDisableSlScreenImageButton();
    },
  },
  computed: {
    activeSlideset() {
      return this.$store.getters['archive/activeSlideset'];
    },
    activeSlide() {
      return this.$store.getters['archive/activeSlide'];
    },
  },
  methods: {
    enableDisableSSRiButton() {
      if (this.activeSlideset && this.activeSlideset.relatedItems && this.activeSlideset.relatedItems.length > 0) {
        this.enableNavItem('ss-relateditems');
      } else {
        this.disableNavItem('ss-relateditems');
      }
    },
    enableDisableSSTextButton() {
      if (this.activeSlideset && this.activeSlideset.texts && this.activeSlideset.texts.length > 0) {
        this.enableNavItem('ss-text');
      } else {
        this.disableNavItem('ss-text');
      }
    },
    enableDisableSlRiButton() {
      if (this.activeSlide && this.activeSlide.relatedItems && this.activeSlide.relatedItems.length > 0) {
        this.enableNavItem('s-relateditems');
      } else {
        this.disableNavItem('s-relateditems');
      }
    },
    enableDisableSlTextButton() {
      const sl = this.activeSlide;
      if (sl && sl._source) {
        for (const linkedSS of sl._source['56_Slide_Sets']) {
          if (linkedSS.slmasssss === this.$route.params.ssid) {
            if (linkedSS.slmassstext) {
              this.enableNavItem('s-text');
              break;
            }
          }
        }
      } else {
        this.disableNavItem('s-text');
      }
    },
    enableDisableSlDetailButton() {
      if (this.activeSlide && this.activeSlide.$_images && this.activeSlide.$_images.length > 0) {
        let foundDetailImg = false;
        for (const a of this.activeSlide.$_images) {
          if (a.sourcename.match(/@detail/g)) {
            foundDetailImg = true;
          }
        }
        if (foundDetailImg) {
          this.enableNavItem('s-details');
        } else {
        this.disableNavItem('s-details');
        }
      } else {
        this.disableNavItem('s-details');
      }
    },
    enableDisableSlScreenImageButton() {
      if (this.activeSlide && this.activeSlide.$_images && this.activeSlide.$_images.length > 0) {
        let foundScreenImg = false;
        for (const a of this.activeSlide.$_images) {
          if (a.sourcename.match(/@screen/g)) {
            foundScreenImg = true;
          }
        }
        if (foundScreenImg) {
          this.enableNavItem('s-imageview');
        } else {
        this.disableNavItem('s-imageview');
        }
      } else {
        this.disableNavItem('s-imageview');
      }
    },
    enableNavItem(id) {
      const toChangeItem = this.navList.find(it => it.id === id);
      if (toChangeItem) {
        toChangeItem.disabled = false;
      }
    },
    disableNavItem(id) {
      const toChangeItem = this.navList.find(it => it.id === id);
      if (toChangeItem) {
        toChangeItem.disabled = true;
      }
    },
    clickNavItem(it) {
      if (it.disabled) {
        return;
      }
      const items = this.$store.getters['archive/viewNavItems'];
      let n1;
      let n2;
      let n3;
      items.filter(a => a.active === true).forEach(a => {
        if (a.group === 2) {
          n2 = a;
        } else if (a.group === 3) {
          n3 = a;
        } else if (a.group === 1) {
          n1 = a;
        }
      });

      let viewId = it.id;

      if (n2 && it.group === 3) {
        viewId = [n2.id, it.id].join(',');
      } else if (n3 && it.group === 2) {
        viewId = [n3.id, it.id].join(',');
      } else if (viewId === 's-text' || 
        (n2 && n2.id === 's-text' && viewId === 's-text') || 
        (n2 && n2.id === 's-imageview' && viewId === 's-text')
      ) {
        viewId = ['s-text', 's-imageview'].join(',');
      }
      this.$routerUpdateQuery(this, {
        view: viewId
      });
    },

    getIcon(name) {
      return this.$getIcon(name);
    },

    getStyle(b) {
      const activeGroup = this.$store.getters['archive/activeViewGroup'];
      if (b.group === 2 && activeGroup === 1 && b.id !== 's-objectview') {
        return 'visibility:hidden';
      }
    }
  }
});
</script>

<style lang="scss" scoped>
a {
  cursor: pointer;
  margin-right:10px;
}

img {
  width: 30px;
  height: 30px;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
}

.pk-nav-item-disabled {
  cursor: default;
}
</style>